import styled from 'styled-components';
import { AccordionItem } from 'react-accessible-accordion';

import { defaultBackground, defaultBorder, defaultColors } from '../../styles/style-guide';

export const StyledAccordionItem = styled(AccordionItem)<{ primaryColor?: string }>`
  padding: 0.75rem 1.5rem;
  border-width: 1px;
  border-radius: 0.5rem;
  background-color: rgb(255 255 255 / 1);
  border-color: ${({ primaryColor }) => (primaryColor ? primaryColor : defaultBorder.primary)};
`;
export const StyledHeading = styled.h3<{ primaryColor?: string }>`
  color: ${({ primaryColor }) => (primaryColor ? primaryColor : defaultColors.primary)};
  font-weight: 700;
`;
export const StyledSubTitle = styled.span<{ secondaryColor?: string }>`
  color: ${({ secondaryColor }) => (secondaryColor ? secondaryColor : defaultColors.secondary)};
  font-weight: 600;
`;
export const StyledButton = styled.button<{ $primaryColor?: string; $borderColor?: string }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.25rem 1rem;
  border-width: 2px;
  border-radius: 0.375rem;
  border-color: ${({ $borderColor }) => $borderColor || defaultBorder.primary};
  color: ${({ $primaryColor }) => $primaryColor || defaultColors.primary};
`;
export const StyledProcessingTimeContainer = styled.div<{ $borderColor?: string }>`
  margin-right: 1rem;
  width: 30%;
  border: 2px solid;
  border-color: ${({ $borderColor }) => $borderColor || defaultBorder.primary};
  border-radius: 0.375rem;
  padding: 0.5rem;
`;

export const StyledProcessingTime = styled.span<{ $primaryColor?: string }>`
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  height: 1.25rem;
  color: ${({ $primaryColor }) => $primaryColor || defaultColors.primary};
`;

export const StyledValueContainer = styled.div<{ $borderColor?: string, $primaryColor?: string }>`
  width: 30%;
  min-width: 115px;
  border: 2px solid;
  border-color: ${({ $borderColor }) => $borderColor || defaultBorder.primary};
  border-radius: 0.375rem;
  padding: 0.75rem 0;
  text-align: center;
  color: ${({ $primaryColor }) => $primaryColor || defaultColors.primary};
`;

export const StyledValue = styled.p<{ $primaryColor?: string }>`
  font-size: 24px;
  font-weight: 800;
  color: ${({ $primaryColor }) => $primaryColor || defaultColors.primary};
`;

export const StyledStepsContainer = styled.div<{ $borderColor?: string }>`
  width: 20%;
  min-width: 300px;
  border: 2px solid;
  border-color: ${({ $borderColor }) => $borderColor || defaultBorder.primary};
  border-radius: 0.375rem;
  padding: 0.5rem;
`;

export const StyledSteps = styled.span<{ $primaryColor?: string }>`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: ${({ $primaryColor }) => $primaryColor || defaultColors.primary};
`;

export const StyledModalButton = styled.button<{ $backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  height: 3rem;
  width: 63%;
  min-width: 242px;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: rgb(255 255 255 / 1);
  background-color: ${({ $backgroundColor }) => $backgroundColor || defaultBackground.primary};
`;

export const StyledModalButtonHandle = styled.button<{ $backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
  height: 3rem;
  width: auto;
  min-width: 242px;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: rgb(255 255 255 / 1);
  background-color: ${({ $backgroundColor }) => $backgroundColor || defaultBackground.primary};
`;
